import React, { ReactPortal, useEffect, useState } from "react";
import ReactDOM from "react-dom";

import {
    Modal,
    ModalClose,
    ModalContentScroll,
    ModalFooter,
    ModalHeader,
    Overlay,
    Wrapper,
} from "#app/components/forms/ModalForm/styles";

import CloseIcon from "./images/close.svg";

interface ModalFormProps {
    modalVisible?: any;
    closeForm?: any;
    children?: any;
    header?: any;
    width?: any;
    height?: any;
    noScroll?: boolean;
    /** Уникальный id для крестика закрытия в шапке модалки (для автотестов) */
    closeId?: string;
}

const ModalForm = ({
    modalVisible,
    closeForm,
    children,
    header = "",
    width = "auto",
    height = "90%",
    noScroll = false,
    closeId,
}: ModalFormProps): null | ReactPortal => {
    const [overlayOpacity, setOverlayOpacity] = useState<string | number>(0);
    const [overlayTransform, setOverlayTransform] = useState<number | string>("0.1");

    useEffect(() => {
        setOverlayOpacity(1);
        setOverlayTransform(1);
    }, []);

    if (!modalVisible) return null;
    let modalElement: HTMLElement | null = document.getElementById("modal");
    if (!modalElement) return null;

    const handleClose = () => {
        setTimeout(() => {
            closeForm && closeForm();
        }, 100);
    };

    return ReactDOM.createPortal(
        <Overlay style={{ opacity: overlayOpacity }}>
            <Wrapper style={{ transform: `scale(${overlayTransform})` }}>
                <Modal width={width} allowRelativeWidthOnMedia={true}>
                    <ModalHeader>
                        {header && <div>{header}</div>}
                        <ModalClose id={closeId} onClick={handleClose}>
                            <img src={CloseIcon as string} alt="Close" />
                        </ModalClose>
                    </ModalHeader>
                    <ModalFooter>
                        {noScroll ? children : <ModalContentScroll>{children}</ModalContentScroll>}
                    </ModalFooter>
                </Modal>
            </Wrapper>
        </Overlay>,
        modalElement
    );
};

export default ModalForm;
